import { render } from "./AppHeader.vue?vue&type=template&id=4b581a4e&scoped=true"
import script from "./AppHeader.vue?vue&type=script&lang=js"
export * from "./AppHeader.vue?vue&type=script&lang=js"

import "./AppHeader.vue?vue&type=style&index=0&id=4b581a4e&scoped=true&lang=css"

import exportComponent from "/dev/shm/repo/portfolio-dp7mkww8fwx8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b581a4e"]])

export default __exports__